import axios from 'axios'
import store from '@/store/index'
import vue from 'vue'

axios.interceptors.request.use(
  config => {
    if (window.localStorage.getItem('access-token')) {
      config.headers.Authorization = window.localStorage.getItem('access-token');
    }
    store.state.loading = true
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    return Promise.resolve(error.response)
  }
)

function checkStatus(response) {
  //console.log(response.data)
  if (response == undefined) {
    // this.$message({
    //   type: 'warning',
    //   message: response
    // })
  } else if (response.data.code == '-20014') {
    vue.prototype.$message({type:"warning",message:response.data.msg});
    store.commit('LOGIN_OUT')
    /* 防止切换角色时addRoutes重复添加路由导致出现警告 */
    window.location.reload()
  } else if (response.data.code == '401') {
    vue.prototype.$message({type:"warning",message:"长时间未操作，请你重新登录"});
    store.commit('LOGIN_OUT')
    /* 防止切换角色时addRoutes重复添加路由导致出现警告 */
    window.location.reload()
  } else {
    // loading
    // 如果http状态码正常，则直接返回数据
    if (
      response &&
      (response.status === 200 ||
        response.status === 304 ||
        response.status === 400)
    ) {
      return response
      // 如果不需要除了data之外的数据，可以直接 return response.data
    }
    // 异常状态下，把错误信息返回去
    return {
      status: -404,
      msg: '网络异常'
    }
  }
}

function checkCode(res) {
  // 如果code异常(这里已经包括网络错误，服务器错误，后端抛出的错误)，可以弹出一个错误提示，告诉用户
  if (res.status === -404) {
    vue.prototype.$message({type:"warning",message:res.data.msg});
  }
  if (res.data && !res.data.success) {
    if (res.data.code == '-44444' || res.data.code == '-44445') {
      store.commit('LOGIN_OUT')
      vue.prototype.$message({type:"warning",message:res.data.msg});
      /* 防止切换角色时addRoutes重复添加路由导致出现警告 */
      window.location.reload()
    }
  }
  return res
}
export default {
  posts({url,data}) {
    let UserToken = store.state.UserToken

    if (UserToken != null && UserToken != '') {
      //data.token = UserToken
      return axios({
          method: 'post',
          baseURL: window.g.APP_URL_PATH,
          url: url,
          data: data,
          dataType: 'json',
          headers: {},
          timeout: 120000
        })
        .then(response => {
          return checkStatus(response)
        })
        .then(res => {
          return checkCode(res)
        })
    } else {
      return axios({
          method: 'post',
          baseURL: window.g.APP_URL_PATH,
          url: url,
          data: data,
          dataType: 'json',
          timeout: 120000
        })
        .then(response => {
          return response
        })
        .then(res => {
          return checkCode(res)
        })
    }
  },
  post({url,data}) {
    let UserToken = store.state.UserToken

    if (UserToken != null && UserToken != '') {
      //data.token = UserToken
      return axios({
          method: 'post',
          baseURL: window.g.APP_URL_PATH,
          url: url,
          data: data,
          dataType: 'json',
          headers: {},
          timeout: 120000
        })
        .then(response => {
          return checkStatus(response)
        })
        .then(res => {
          return checkCode(res)
        })
    } else {
      return axios({
          method: 'post',
          baseURL: window.g.APP_URL_PATH,
          url: url,
          data: data,
          dataType: 'json',
          timeout: 120000
        })
        .then(response => {
          return checkStatus(response)
        })
        .then(res => {
          return checkCode(res)
        })
    }
  },put({url,data}) {
    let UserToken = store.state.UserToken

    if (UserToken != null && UserToken != '') {
      //data.token = UserToken
      return axios({
          method: 'put',
          baseURL: window.g.APP_URL_PATH,
          url: url,
          data: data,
          dataType: 'json',
          headers: {},
          timeout: 120000
        })
        .then(response => {
          return checkStatus(response)
        })
        .then(res => {
          return checkCode(res)
        })
    } else {
      return axios({
          method: 'put',
          baseURL: window.g.APP_URL_PATH,
          url: url,
          data: data,
          dataType: 'json',
          timeout: 120000
        })
        .then(response => {
          return checkStatus(response)
        })
        .then(res => {
          return checkCode(res)
        })
    }
  },
  get({url,data}) {
    let UserToken = store.state.UserToken

    if (UserToken != null && UserToken != '') {
      //data.token = UserToken
      return axios.get(window.g.APP_URL_PATH+url, {
        params: data
        }).then(response => {
          return checkStatus(response)
        })
        .then(res => {
          return checkCode(res)
        })
    } else {
      return axios.get(window.g.APP_URL_PATH+url, {
        params: data
        })
        .then(response => {
          return checkStatus(response)
        })
        .then(res => {
          return checkCode(res)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/trans/http.js